module.exports = __webpack_public_path__ + "img/sbc_common.ae655fd1.png";